import { render, staticRenderFns } from "./dialogAuth.vue?vue&type=template&id=52648bfe&"
import script from "./dialogAuth.vue?vue&type=script&lang=js&"
export * from "./dialogAuth.vue?vue&type=script&lang=js&"
import style0 from "./dialogAuth.vue?vue&type=style&index=0&id=52648bfe&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports